import { create } from "zustand";
import { persist } from "zustand/middleware";

export const DASHBOARD_DISPLAY_CCY_OPTIONS = ["RUB", "USD", "EUR", "CNY", "GBP"] as const;
export type DashboardDisplayCcy = (typeof DASHBOARD_DISPLAY_CCY_OPTIONS)[number];

interface DashboardDisplayState {
  displayCcy: DashboardDisplayCcy;
  setDisplayCcy: (ccy: DashboardDisplayCcy) => void;
}

export const useDashboardDisplayStore = create<DashboardDisplayState>()(
  persist(
    (set) => ({
      displayCcy: "RUB",
      setDisplayCcy: (displayCcy) => set({ displayCcy }),
    }),
    { name: "atlas.dashboard.display" },
  ),
);

/** Query params for positions snapshot/summary when display currency conversion is enabled. */
export function dashboardDisplayQueryParams(
  displayCcy: string,
): Record<string, string> {
  const ccy = displayCcy.trim();
  if (!ccy) return {};
  return { display_ccy: ccy };
}
